import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// GET ALL
export const GetAllCity = createAsyncThunk(
  "masters/city/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.City}?name=${filter?.name || ""}&country_id=${
          filter?.country_id || ""
        }&state_id=${
          filter?.state_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );


      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//GET SINGLE
export const GetCity = createAsyncThunk(
  "masters/city/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.City}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//CREATE
export const AddCity = createAsyncThunk(
  "masters/city/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.City, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// UPDATE
export const UpdateCity = createAsyncThunk(
  "masters/city/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Masters.City}/${id}`,
        data, // send FormData
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//DELETE
export const DeleteCity = createAsyncThunk(
  "masters/city/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.City}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// STATUS
export const StatusCity = createAsyncThunk(
  "masters/city/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.City}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "city",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // GET ALL
      .addCase(GetAllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //GET SINGLE
      .addCase(GetCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetCity.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //CREATE
      .addCase(AddCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddCity.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        //state.data.unshift(action.payload?.data);
      })
      .addCase(AddCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //UPDATE
      .addCase(UpdateCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex((item) => item.id === updated?.id);

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(UpdateCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //DELETE
      .addCase(DeleteCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(DeleteCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //STATUS
      .addCase(StatusCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex((item) => item.id === updated?.id);

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(StatusCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
